<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BkoOF/tc-custom/9781452164854.jpg?1705766123702" alt="This image is the cover for the book Take a Hike, Miles and Spike!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Take a Hike, Miles and Spike!
      </h1>
      <p class="bookDescription body article font2">
        <b>The creators of <i>Give Me Back My Book!</i> deliver “an environmental message that goes down easily amid the cartoony cast” (</b><b><i>Kirkus Reviews</i></b><b>).</b><br/>  <br/> Take care, GRIZZLY BEAR! Stay loose, MOOSE! Buh-bye, BUTTERFLY! Join Miles and Spike as they take a hike . . . and a few provisions, as well, much to the vexation of their fellow forest creatures. Travis Foster and Ethan Long offer a hilarious picture book full of silly rhymes, outdoor adventures, and learning how to get along with others.<br/>  <br/><b>“Audiences who get the giggles from hearing ‘see you later, alligator’ are going to find plenty to love (and repeat).” —<i>Publishers Weekly</i></b><br/>  <br/><b>“Foster and Long’s hilariously pithy rhymes are perfectly paired with cheerful comic illustrations, both good enough to make a popular TV cartoon sitcom . . . An enticing picture book sure to win over any storytime crowd with its rollicking rhymes and enduring message.” —<i>School Library Journal</i></b><br/>  <br/><b>“Hilarious . . . Miles and Spike prove that learning manners can be enjoyable.” —<i>BookPage</i></b><br/>  <br/><b>“Young audiences will have no trouble catching on to the pattern and chiming in with the appropriate rhymes.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Travis Foster, Ethan Long
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c33a8416